import { Reveal } from "@/components/Reveal";
import { STEPS } from "@/data/site";

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="mx-auto max-w-7xl scroll-mt-24 px-5 py-20 sm:px-8 lg:py-28">
      <Reveal className="max-w-2xl">
        <p className="text-sm font-semibold uppercase tracking-[0.15em] text-marigold-deep">How it works</p>
        <h2 className="mt-3 font-heading text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
          Up and running in minutes
        </h2>
        <p className="mt-4 text-lg text-muted-foreground">
          Three simple steps to bring your whole family together.
        </p>
      </Reveal>

      <div className="relative mt-14">
        <div className="absolute left-[27px] top-4 hidden h-[calc(100%-2rem)] w-px bg-border md:block" />
        <div className="grid gap-10 md:grid-cols-3 md:gap-8">
          {STEPS.map((step, i) => (
            <Reveal key={step.title} delay={i * 0.1} className="relative">
              <div className="flex items-start gap-5 md:flex-col md:gap-6">
                <div className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary font-heading text-xl font-bold text-primary-foreground shadow-lg">
                  {i + 1}
                </div>
                <div>
                  <h3 className="font-heading text-xl font-semibold text-foreground">{step.title}</h3>
                  <p className="mt-2 text-base leading-relaxed text-muted-foreground">{step.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
